import { useSettings } from '@capsicum/common';

import { useAvailableMarketsQuery } from '../data-access/queries/useAvailableMarketsQuery';

export const useMarketAvailability = (currencyId?: string) => {
	const {
		data: availableMarketsData,
		error: availableMarketsError,
		isLoading
	} = useAvailableMarketsQuery(currencyId ? { baseCurrencyIds: [currencyId] } : {}, {
		enabled: !!currencyId
	});

	const { settings } = useSettings();
	const { isFanTokenDirectPurchaseEnabled, isMarketplaceFanTokenBuyEnabled, isMarketplaceFanTokenSellEnabled } =
		settings;

	const isMarketSellAllowed = Boolean(currencyId && availableMarketsData?.[0]?.isSellAllowed);
	const isSellEnabled = !isLoading && isMarketplaceFanTokenSellEnabled && isMarketSellAllowed;

	const isMarketBuyAllowed = Boolean(currencyId && availableMarketsData?.[0]?.isBuyAllowed);
	const isBuyEnabled =
		!isLoading && isFanTokenDirectPurchaseEnabled && isMarketplaceFanTokenBuyEnabled && isMarketBuyAllowed;

	const errors = [availableMarketsError];

	return {
		availableMarketsData,
		errors,
		isBuyEnabled,
		isLoading,
		isMarketAvailable: !!availableMarketsData?.length,
		isSellEnabled
	};
};
